module.exports = __webpack_public_path__ + "img/M804.98e567e8.jpg";